<template>
  <div class="index">
    <div class="cities">
      <div class="centered city-addition">
        <draggable v-model="agenciesObject" :options="{ disabled: editableOffice !== null }">
          <span v-for="agency in agenciesObject" @click="handleGetAgency" class="city-wrapper">
            <router-link
            v-if="editableOffice !== agency.id"
            :to="{ name: 'Office', params: { id: agency.id }  }"
            :class="$route.params.id === agency.id || !$route.params.id && agencies[0].id === agency.id? 'is-active' : '' "
            class="city-title">{{agency.city}} </router-link>
            <span v-else class="edit-city-wrapper">
              <a class="delete hide-edit-city" @click="toggleEditOffice(agency.id)"></a>
              <b-input v-model="newAgencyCity"
              class="edit-city-input"></b-input>
              <img src="/static/img/icons/apply.svg" class="apply-icon is-medium" @click="handleUpdateOffices"/>
            </span>
            <img src="/static/img/icons/edit.svg" class="edit-icon" @click="toggleEditOffice(agency.id)"/>
          </span>
        </draggable>
        <span class="button-wrapper city-addition-wrapper" @click="toggleCityAddition" v-if="!cityAdditionVisible">
          <a class="button is-info">+</a> Добавить город
        </span>
        <b-field class="city-addition-input" v-if="cityAdditionVisible">
            <b-input placeholder="Введите название города" v-model="cityName"></b-input>
            <span class="city-addition-button is-primary button" @click="handleAddCity">Добавить</span>
            <span class="city-addition-button is-warning button" @click="toggleCityAddition">Отмена</span>
        </b-field>
      </div>
    </div>
    <div class="agency-information" v-if="agencyObject">
      <div class="announcement" v-if="agencyObject.announcement">
        <img src="/static/img/icons/delete.svg" class="delete-icon" @click="toggleAnnouncement"/>
        <b-field class="title">
          <b-input placeholder="Заголовок объявления" v-model="agencyObject.announcement.title"/>
        </b-field>
        <b-field>
          <b-input placeholder="Текст объявления" v-model="agencyObject.announcement.description"/>
        </b-field>
        <span>Период размещения объявления на сайте</span>
        <div class="columns">
          <div class="column is-half">
            <el-date-picker
              type="date"
              :editable="false"
              v-model="announcement.startDate"
              @change="announcementDataChanged"
              placeholder="c">
            </el-date-picker>
          </div>
          <div class="column is-half">
            <el-date-picker
              type="date"
              :editable="false"
              v-model="announcement.endDate"
              @change="announcementDataChanged"
              placeholder="по">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="columns contacts">
        <div class="column is-one-quarter">
          <span class="has-text-centered agency-photo-title">Иконка (отображается на главной)</span>
          <div class="rounded-photo-wrapper agency-photo centered"  v-bind:style="photoContainerStyle">
            <div v-if="!agencyObject.photo" @click="handleLoadPhoto">
              <span>Загрузить фото представительства</span>
            </div>
            <img  v-else src="/static/img/icons/delete.svg" class="delete-icon" @click="deletePhoto"/>
          </div>
          <input type="file" id='photo' @change='loadPhoto' hidden ref="loadPhotoButton"/>
        </div>
        <div class="column">
          <span class="button-wrapper is-marginless" @click="toggleAnnouncement" v-if="!agencyObject.announcement">
            <a class="button is-info">+</a>Добавить объявление о празднике и время работы
          </span>
          <p class="time-title">Время работы</p>
          <p class="time-desription">незаполненные поля считаются за выходной день и не отображаются на сайте</p>
          <div class="schedule">
            <div class="day centered">
              <span class="day-title">ПН</span>
              <b-input placeholder="00:00" v-model="agencyObject.schedule.monStart"/>
              —
              <b-input placeholder="00:00" v-model="agencyObject.schedule.monEnd"/>
            </div>
            <div class="day centered">
              <span class="day-title">ВТ</span>
              <b-input placeholder="00:00" v-model="agencyObject.schedule.tueStart"/>
              —
              <b-input placeholder="00:00" v-model="agencyObject.schedule.tueEnd"/>
            </div>
            <div class="day centered">
              <span class="day-title">СР</span>
              <b-input placeholder="00:00" v-model="agencyObject.schedule.wedStart"/>
              —
              <b-input placeholder="00:00" v-model="agencyObject.schedule.wedEnd"/>
            </div>
            <div class="day centered">
              <span class="day-title">ЧТ</span>
              <b-input placeholder="00:00" v-model="agencyObject.schedule.thuStart"/>
              —
              <b-input placeholder="00:00" v-model="agencyObject.schedule.thuEnd"/>
            </div>
            <div class="day centered">
              <span class="day-title">ПТ</span>
              <b-input placeholder="00:00" v-model="agencyObject.schedule.friStart"/>
              —
              <b-input placeholder="00:00" v-model="agencyObject.schedule.friEnd"/>
            </div>
            <div class="day centered">
              <span class="day-title">СБ</span>
              <b-input placeholder="00:00" v-model="agencyObject.schedule.satStart"/>
              —
              <b-input placeholder="00:00" v-model="agencyObject.schedule.satEnd"/>
            </div>
            <div class="day centered">
              <span class="day-title">ВС</span>
              <b-input placeholder="00:00" v-model="agencyObject.schedule.sunStart"/>
              —
              <b-input placeholder="00:00" v-model="agencyObject.schedule.sunEnd"/>
            </div>
          </div>
          <b-field label="адрес представительства" class="agency-address">
              <b-input placeholder="адрес" v-model="agencyObject.address" v-on:blur="getAddress()"/>
          </b-field>
        </div>
        <div class="column">
          <b-field label="email представительства">
              <b-input placeholder="email" v-model="agencyObject.email"/>
          </b-field>
          <b-field label="телефон представительства ">
              <b-input placeholder="телефон" v-model="agencyObject.phone" />
          </b-field>
          <b-field label="почтовый индекс">
              <b-input placeholder="индекс" v-model="agencyObject.index" />
          </b-field>
        </div>
      </div>
      <div class="map-container">
        <h2 class="has-text-centered">Укажите адрес на карте</h2>
        <gmap-map
          :center="center"
          :zoom="15"
          style="height: 350px"
          :options="{scrollwheel: false}"
          @click="selectAddress"
        >
          <gmap-marker
           :key="index"
           v-for="(m, index) in markers"
           :position="m.position"
           :clickable="true"
           :draggable="true"
          ></gmap-marker>
        </gmap-map>
        <div class="centered"><div class="button delete-pin" @click="deletePin">Удалить метку</div></div>
      </div>
      <h2>Консультанты</h2>
      <div class="consultants columns is-multiline">
        <Consultant v-for="consultant in agencyObject.consultants" :consultant="consultant" v-if="consultant.type==='common'" :key="consultant.id"/>
      </div>
      <div class="centered">
        <span class="button-wrapper" @click="createCommonConsultant">
          <a class="button is-info">+</a> Добавить специалиста
        </span>
      </div>
      <h2>Клиентский отдел</h2>
      <div class="consultants columns is-multiline">
        <Consultant v-for="consultant in agencyObject.consultants" :consultant="consultant" v-if="consultant.type==='client'" :key="consultant.id"/>
      </div>
      <div class="centered">
        <span class="button-wrapper" @click="createClientConsultant">
          <a class="button is-info">+</a> Добавить специалиста
        </span>
      </div>
      <div class="save-content-button centered">
        <button class="button save-content" @click="handleSaveAgency()" :disabled="disabled">{{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}</button>
      </div>
      <div class="delete-agency has-text-centered" @click="deleteAgency(agencyObject.id)">Удалить представительство</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Consultant from 'components/About/Consultant'
import deepcopy from 'deepcopy'
import * as VueGoogleMaps from 'vue2-google-maps'
import draggable from 'vuedraggable'
import uuidv4 from 'uuid/v4'
import axios from 'axios'

export default {

  data () {
    return {
      cityName: '',
      cityAdditionVisible: false,
      agencyObject: null,
      updateTimer: null,
      editableOffice: null,
      announcement: {
        startDate: '',
        endDate: ''
      },
      center: null,
      newAgencyCity: '',
      markers: [],
      disabled: false
    }
  },
  computed: {
    ...mapState(['agencies', 'agency']),
    agenciesObject: {
      get () {
        return deepcopy(this.agencies)
      },
      set (val) {
        for (let i = 0; i < val.length; i++) {
          if (val[i].id === this.agenciesObject.id) {
            val[i] = this.agenciesObject
          }
          val[i].order = i
        }
        this.updateAgencies(val)
      }
    },
    photoContainerStyle () {
      return this.agencyObject.photo
      ? {background: this.agencyObject.photo.base64photo
        ? `url(${this.agencyObject.photo.base64photo})`
        : `url(/upload/photos/${this.agencyObject.photo}) #fff`,
        'background-size': 'contain'}
      : {background: ''}
    }
  },
  watch: {
    agency: {
      handler (value) {
        this.agencyObject = deepcopy(value)
        this.markers = []
        if (value.announcement) {
          this.announcement.startDate = value.announcement.startDate
          this.announcement.endDate = value.announcement.endDate
        }
        if (value.location) {
          const point = value.location.split(',')
          const position = {
            lat: parseFloat(point[0]), lng: parseFloat(point[1])
          }
          this.center = position
          this.markers.push({
            position: position
          })
        } else {
          this.getAddress()
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['addAgency', 'getAgency', 'getAgencies',
      'updateAgency', 'deleteAgency', 'addConsultant', 'saveAgency',
      'updateAgencies']),
    toggleCityAddition () {
      this.cityAdditionVisible = !this.cityAdditionVisible
    },
    handleSaveAgency () {
      this.disabled = true
      this.saveAgency(this.agencyObject)
      .then(() => {
        this.disabled = false
        this.$toast.open({ message: 'Сохранено' })
      })
    },
    handleAddCity () {
      /* eslint-disable object-property-newline */
      const schedule = {
        monStart: '', monEnd: '',
        tueStart: '', tueEnd: '',
        wedStart: '', wedEnd: '',
        thuStart: '', thuEnd: '',
        friStart: '', friEnd: '',
        satStart: '', satEnd: '',
        sunStart: '', sunEnd: ''
      }
      this.addAgency({
        city: this.cityName,
        id: uuidv4(),
        isNew: true,
        schedule,
        consultants: [],
        announcement: null
      })
      this.cityName = ''
      this.toggleCityAddition()
    },
    announcementDataChanged () {
      this.agencyObject.announcement.startDate = this.announcement.startDate
      this.agencyObject.announcement.endDate = this.announcement.endDate
    },
    toggleAnnouncement () {
      if (!this.agencyObject.announcement) {
        this.agencyObject.announcement = { agency_id: this.agencyObject.id, id: uuidv4() }
      } else {
        this.agencyObject.announcement = null
      }
      this.handleUpdateAgency()
    },
    deletePin () {
      this.agencyObject.location = ''
      this.markers = []
    },
    handleUpdateOffices () {
      const agency = this.agenciesObject.find(a => a.id === this.editableOffice)
      this.editableOffice = null
      agency.city = this.newAgencyCity
      this.updateAgencies(this.agenciesObject)
    },
    handleUpdateAgency () {
      this.updateAgency(this.agencyObject)
    },
    loadPhoto (e) {
      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('avatar', file)
      reader.onload = (e) => {
        this.agencyObject.photo = {
          base64photo: e.target.result,
          data: formData
        }
        this.updateAgency(this.agencyObject)
      }
    },
    toggleEditOffice (id) {
      if (this.editableOffice === id) {
        id = null
        this.newAgencyCity = ''
      } else {
        const agency = this.agenciesObject.find(a => a.id === id)
        this.newAgencyCity = agency.city
      }
      this.editableOffice = id
    },
    deletePhoto () {
      this.agencyObject.photo = null
      this.updateAgency(this.agencyObject)
    },
    createCommonConsultant () {
      this.addConsultant({ agency_id: this.agencyObject.id, type: 'common', id: uuidv4(), isHidden: false })
    },
    createClientConsultant () {
      this.addConsultant({ agency_id: this.agencyObject.id, type: 'client', id: uuidv4(), isHidden: false })
    },
    handleLoadPhoto () {
      if (!this.agencyObject.photo) {
        this.$refs.loadPhotoButton.click()
      }
    },
    handleGetAgency () {
      if (!this.agency || this.$route.params.id !== this.agency.id) {
        this.getAgency(this.$route.params.id)
      }
    },
    selectAddress (data) {
      this.agencyObject.location = `${data.latLng.lat()}, ${data.latLng.lng()}`
      this.markers = []
      const position = { lat: data.latLng.lat(), lng: data.latLng.lng() }
      this.markers.push({ position })
      setTimeout(() => { this.center = position }, 400)
    },
    getAddress () {
      const axiosInstance = axios.create()
      const address = `${this.agencyObject.city} ${this.agencyObject.address || ''}`
      const place = encodeURIComponent(address)
      axiosInstance.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${place}&key=AIzaSyC36JGZn_Nl3Go2QyT9PQdnT8uACjbrSdE`)
      .then(({ data }) => {
        if (data.results[0]) {
          this.center = data.results[0].geometry.location
        }
      })
    }
  },
  created () {
    this.getAgencies(this.$route.params.id)
    if (this.$route.params.id && !this.agency) {
      this.getAgency(this.$route.params.id)
    }
    this.center = {
      lat: 56.83779946755993,
      lng: 60.59916973114014
    }
  },
  components: { Consultant, VueGoogleMaps, draggable }
}
</script>

<style scoped>
@import "../../global.css";
.contacts,
.announcement {
  max-width: 1200px;
  margin: 30px auto 0;
}
.agency-photo-title {
  font-size: 1.1em;
}
.agency-photo {
  margin: 15px 0 0;
  width: 200px;
  height: 200px;
}
.time-title {
  margin: 15px 0 0;
  font-weight: bold;
}
.time-title,
.time-description {
  color: #7a7a7a;
}
.day {
  margin: 10px 0;
  justify-content: flex-start;
}
.day .control {
  max-width: 120px;
  display: inline-block;
  margin: auto 10px;
}
.day .control input {
  text-align: center;
}
.agency-address {
  margin: 40px 0;
}
h2 {
  text-align: center;
}
.consultants {
  margin: 15px 0px;
}
.delete-agency {
  margin: 20px 0 0;
  background: red;
  color: white;
  padding: 20px;
  cursor: pointer;
}
.save-content {
  margin: 25px 0 15px;
}
</style>
<style>
.announcement .title input {
  font-size: 1.6em;
}
.announcement {
  margin: 30px 40px 50px;
  position: relative;
  padding: 20px 50px;
  background: #eee;
}
.announcement .delete-icon {
  width: 30px;
  top: 8px;
  right: 8px;
}
.announcement .el-date-editor {
  width: 100%;
}
.announcement .control {
  margin: 20px 0;
}
.rounded-photo-wrapper {
  background: #d6d6d6;
  display: inline-flex;
  border: 1px solid #d6d6d6;
  position: relative;
  border-radius: 50%;
  cursor: pointer;
  text-align: center;
  color: #1464f6;
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: contain !important;
}
.map-container {
  margin: -30px 0 0;
}
.schedule {
  font-family: monospace;
}
</style>



// WEBPACK FOOTER //
// Contacts.vue?a7781ecc